module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsSAAALEgHS3X78AAAA0UlEQVRIibXV0RGDIAwG4NBzgJ4T8MIsvLqBdJN2kuoYzuKLE7ACfYGexUAFfvNm7sx3STgQzjm6OjoiIqvVXpr7ZTVI5MbkRqvVdDUChwIyIyGrlbFaPa1WhohIhMX7giPzT9GOfOH3LvX4jssXQnQ0RN/yZycg6B4nDosHdpRGroBSRxgKJREklEVQ0F8EAZ1CWqHTSAtUhNRCovbRytx1cbyKOwmR6egQ1UgJ1HFJf10PxFx2NXFAmPegObhxSSSQQjawsbFH2I9MIoB+WacPs8lw2Ipl5hUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/down_tick_icon.png
// module id = hbAw
// module chunks = 0